export default __webpack_public_path__ + "static/media/37.23aa2a04.jpg";